/* eslint-disable import/no-unresolved */
import React, { memo } from "react";
import { truncate } from "lodash";
import ProductExample from 'images/dashboard/main-img-holder.png';

const SelectedProductWithImage = ({
  product
}) => {
  const {
    title,
    variant_name,
    product_variant_combination_id,
    image_url,
    product_image
  } = product;

  const imageUrl = image_url?.url || product_image?.url || ProductExample;
  const isCombination = !!product_variant_combination_id;

  const renderVariantText = (text) => (
    <div className="tw-flex">
      <span className="tw-flex tw-px-1.5 tw-py-[2px] tw-bg-gray-50 tw-rounded-[5px] tw-tex-gray-700 tw-text-xs">
        {truncate(text, { length: 40 })}
      </span>
    </div>
  );

  return (
    <div className="tw-wrapper">
      <div className="tw-flex tw-items-center tw-gap-2.5">
        <div
          className="tw-w-[42px] tw-h-[42px] tw-rounded-[5px] tw-flex-shrink-0 tw-bg-gray-200 tw-bg-contain tw-bg-no-repeat tw-bg-center"
          style={{ backgroundImage: `url(${imageUrl})` }}
        />
        <div className="tw-flex tw-flex-col">
          <span className="tw-tex-gray-950">{truncate(title, { length: 40 })}</span>
          {isCombination && (
            renderVariantText(variant_name)
          )}
        </div>
      </div>
    </div>
  );
};

export default memo(SelectedProductWithImage);
